export default __webpack_public_path__ + "static/media/phone.eaff472b.png";